import React, {useEffect, useState} from 'react'
import {QrReader} from 'react-qr-reader'
import {KTSVG} from '../../../helpers'
import useGlobals from '../../../../hooks/useGlobals'
import {useNavigate} from 'react-router-dom'
const QRCodeScanner: React.FC = () => {
  const {desactivateQrCodeCamera} = useGlobals()
  const navigate = useNavigate()
  const [camera, setCamera] = useState<'user' | 'environment'>('environment')
  const [showQrCodeReader, setShowQrCodeReader] = React.useState<boolean>()
  const handleScan = (data: any) => {
    if (data) {
      const {text} = data
      navigate(text)
      desactivateQrCodeCamera()
    }
  }

  const [camerasCount, setCamerasCount] = useState(0)

  const toggleCamera = () => {
    setCamera((prevCamera) => (prevCamera === 'environment' ? 'user' : 'environment'))
  }

  const toggleQrCodeReader = () => {
    setShowQrCodeReader((prev) => (prev === true ? false : true))
  }

  useEffect(() => {
    getCameras()
    navigator.permissions
      // @ts-ignore: Ignore the type error for 'camera'
      .query({name: 'camera'})
      .then((permissionStatus) => {
        console.log('Camera permission state:', permissionStatus.state)

        if (permissionStatus.state === 'granted') {
          setShowQrCodeReader(true)
        } else {
          setShowQrCodeReader(false)
          askForCameraPermission()
        }

        // Listen for changes to the permission status
        permissionStatus.onchange = () => {
          if (permissionStatus.state === 'granted') {
            setShowQrCodeReader(true)
          } else {
            setShowQrCodeReader(false)
            askForCameraPermission()
          }
        }
      })
      .catch(() => {
        setShowQrCodeReader(false)
      })
  }, [])

  const askForCameraPermission = () => {
    navigator.mediaDevices
      .getUserMedia({video: true})
      .then(() => {
        setShowQrCodeReader(true)
      })
      .catch(() => {
        setShowQrCodeReader(false)
      })
  }

  const getCameras = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices()
      const videoDevices = devices.filter((device) => device.kind === 'videoinput')
      setCamerasCount(videoDevices.length)
    } catch (err) {
      setCamerasCount(0)
    }
  }

  return (
    <div>
      <button onClick={toggleQrCodeReader}>QR CODE BUTTON</button>

      {showQrCodeReader ? (
        <>
          <QrReader
            constraints={{
              facingMode: camera,
              aspectRatio: 1,
            }}
            scanDelay={300}
            //onError={handleError}
            onResult={handleScan}
            videoContainerStyle={{
              position: 'fixed',
              width: '100vw',
              height: '100vh',
              zIndex: 999999,
              top: 0,
              left: 0,
              padding: 0,
              backgroundColor: '#2F4F4F',
              //opacity : 0.1
            }}
            ViewFinder={() => (
              <div className='d-flex h-100 justify-content-end gap-3 m-3'>
                {camerasCount > 1 ? (
                  <a
                    className='btn btn-icon btn-bg-light  btn-active-color-primary '
                    style={{
                      zIndex: 9999999,
                    }}
                    onClick={toggleCamera}
                  >
                    <KTSVG
                      path='media/icons/duotune/abstract/abs037.svg'
                      className='svg-icon-2x svg-icon-primary-light'
                    />
                  </a>
                ) : (
                  <></>
                )}
                <a
                  className='btn btn-icon btn-bg-light  btn-active-color-danger'
                  style={{
                    zIndex: 9999999,
                  }}
                  onClick={desactivateQrCodeCamera}
                >
                  <KTSVG
                    path='media/icons/duotune/arrows/arr015.svg'
                    className='svg-icon-2x svg-icon-danger-light'
                  />
                </a>
              </div>
            )}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  )
}

export default QRCodeScanner
